import React from "react";
import CategoryServices from "../services/CategoryServices";
var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut, branchLogin, loginInsector };

// ###########################################################

function loginUser(dispatch, login, password, history, setIsLoading, setError, ) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {
    const  userDetails =   {"email":login,"password":password, }
    CategoryServices.creteUserLogin(userDetails).then((res) => {
      localStorage.setItem('userDetail', JSON.stringify(res));
      localStorage.setItem('id_token', res.token)
      setError(null)
      setIsLoading(false)
      dispatch({ type: 'LOGIN_SUCCESS' });
      if(res && res.registrationType === 'doctor'){
        history.push('/app/clinic') ;
      }else if(res && res.registrationType === 'loan'){
        history.push('/app/branch') ;
      }else if(res && res.registrationType === 'park' ){
        history.push('/app/park') ;
      }else if(res && res.registrationType === 'event'){
        history.push('/app/event') ;
      }else  if(res && res.registrationType === 'exbhition'){
        history.push('/app/exbhition') ;
      }else  if(res && res.registrationType === 'admin'){
        history.push('/app/advatagement') ;
      }
      // else{
      //   history.push('/app/park') ;
      // }
     
       window.location.reload(false);


    }).catch((err) => {
      alert(err.response.data.message)
      setIsLoading(false);
      history.push('/sriqr/login')
    });
  } 
}
function branchLogin(dispatch, login, password, history, setIsLoading, setError, roleType, branchCode) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {
    const  userDetails =   {"counterMobile":login,"password":password, "branchCode":branchCode }
    CategoryServices.creteBranchLogin(userDetails).then((res) => {
      localStorage.setItem('userDetail', JSON.stringify(res));
      localStorage.setItem('id_token', res.token)
      setError(null)
      setIsLoading(false)
      dispatch({ type: 'LOGIN_SUCCESS' });
     
        history.push('/app/counterdetails') ;

       window.location.reload(false);


    }).catch((err) => {
      alert(err.response.data.message)
      setIsLoading(false);
      history.push('/sriqr/branchuser')
    });
  } 

}
function loginInsector(dispatch, login, password, history, setIsLoading, setError, roleType) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {
    const  userDetails =   {"email":login,"password":password}
    CategoryServices.creteInsectorLogin(userDetails).then((res) => {
      localStorage.setItem('userDetail', JSON.stringify(res));
      localStorage.setItem('id_token', res.token)
      setError(null)
      setIsLoading(false)
      dispatch({ type: 'LOGIN_SUCCESS' });
      history.push('/app/searchreports') ;     
       window.location.reload(false);
    }).catch((err) => {
      alert(err.response.data.message)
      setIsLoading(false);
      // history.push('/sriqr/login')
    });
  } 
}
function signOut(dispatch, history) {
  localStorage.removeItem("id_token");
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/sriqr/login");
}
